import { z } from 'zod';

export const OwnedUnit = z.looseObject({
  id: z.number(),
  name: z.string(),
  pms: z.string().nullable().optional(),
  bookable: z.boolean(),
  teamId: z.number(),
  teamName: z.string()
});
export type OwnedUnit = z.infer<typeof OwnedUnit>;

export const OwnedUnits = z.array(OwnedUnit);
export type OwnedUnits = z.infer<typeof OwnedUnits>;

export const OwnerMe = z.looseObject({
  name: z.string().nullable(),
  phone: z.string().nullable(),
  hasBillingCustomer: z.boolean()
});
export type OwnerMe = z.infer<typeof OwnerMe>;

export const CalendarBooking = z.looseObject({
  id: z.number(),
  from: z.string(),
  to: z.string(),
  status: z.enum(['booked', 'checked_in', 'checked_out']),
  type: z.enum(['own', 'rental', 'block']),
  usedBy: z.string().nullable().optional(),
  comment: z.string().nullable().optional()
});
export type CalendarBooking = z.infer<typeof CalendarBooking>;

export const SyncStatus = z.looseObject({
  lastSyncedAt: z.string().nullable(),
  state: z.enum(['idle', 'running', 'failed'])
});
export type SyncStatus = z.infer<typeof SyncStatus>;

/** Nights every unit of the unit's type is taken (unit type locking), `to` exclusive. */
export const LockedPeriod = z.looseObject({
  from: z.string(),
  to: z.string()
});
export type LockedPeriod = z.infer<typeof LockedPeriod>;

export const OwnerCalendar = z.looseObject({
  bookings: z.array(CalendarBooking),
  locked: z.array(LockedPeriod).optional(),
  sync: SyncStatus
});
export type OwnerCalendar = z.infer<typeof OwnerCalendar>;

export interface BlockBody {
  from: string;
  to: string;
  comment?: string;
}

export interface BookStayBody {
  from: string;
  to: string;
  bookingFor: 'self' | 'someone_else';
  visitor?: { name: string; phone: string };
  comment?: string;
  billingCustomer?: { street: string; postcode: string; city: string; phone: string };
  idempotencyKey: string;
}

export interface ChangeStayBody {
  from: string;
  to: string;
  idempotencyKey: string;
}
